module.exports = __webpack_public_path__ + "static/media/Ring.610c6cfa.mp3";